import React from 'react'
import './Projects.css'
import firebase from '../../services/Firebase'
import {
    BrowserRouter as Router, 
    Switch, 
    Route, 
    Link
  } from 'react-router-dom';




function useProjects() {

    const [projects, setProjects] = React.useState([]);


    React.useEffect(() => {
        firebase.firestore().collection('projects').orderBy("timestamp", "asc")
            .onSnapshot((snapshot) => {
                const newProjects = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))
                setProjects(newProjects)
            })
    }, []);

    return projects;

}

function Projects(props) {

    const projects = useProjects();

    return (<>
        <div className="project-grid">


            {projects.map(project =>

                <div className={["project-card"]} key={project.id}>
                    <img className="project-img" src={project.imgurl}></img>

                    <div className="project-description">
                        <h3>{project.name}</h3>
                        <p>{project.caption}</p>
                    </div>

                    <Link to={"/project/"+project.id} className="project-button">Mehr erfahren</Link>
                </div>

            )}

        </div>
    </>)
}

export default Projects;